/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth__Signup__SubtitleInputs */

const en_auth__signup__subtitle = /** @type {(inputs: Auth__Signup__SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join the excitement and experience the rush of victory!`)
};

/**
* | output |
* | --- |
* | "Join the excitement and experience the rush of victory!" |
*
* @param {Auth__Signup__SubtitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth__signup__subtitle = /** @type {((inputs?: Auth__Signup__SubtitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth__Signup__SubtitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth__signup__subtitle(inputs)
});